import {unregisterAllServiceWorkers} from 'serviceWorkers';
import {clearAllCookies} from './cookies';

function resetSession() {
  clearAllCookies();
  localStorage.clear();
  sessionStorage.clear();
  unregisterAllServiceWorkers();
}

export default resetSession;
